export default __webpack_public_path__ + "static/media/close.42de8f8c.svg";